var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9714 3.09313L39 2.39323V0H36.9714H36.6239H30.6202H27.4408L19.4981 20L11.5554 0H2.02491H0V2.39323L3.45205 3.58984L14.7347 32H17.2902H17.9103L27.4408 8V25.5992V28.9069L25.4159 29.6068V32H27.4408H36.9714H39V29.6068L36.9714 28.9069V25.5992V3.09313Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97634 22.5059L3.66127 19.1982H2.02491V21.4108V22.5059V25.599V28.9066L0 29.6065V31.9998H2.02491H4.97634H7.00125V29.6065L4.97634 28.9066V22.5059Z",
    fill: "#FA4443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdmIcon);
export default __webpack_public_path__ + "static/media/MDMIcon.c4fa8179.svg";
export { ForwardRef as ReactComponent };